import Vue from "vue";
import Router from "vue-router";
import SalesData from "../components/SalesData";
import TheLogin from "../components/TheLogin";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: "/sales-dashboard",
    },
    {
      path: "/login",
      name: "Login",
      component: TheLogin,
    },
    {
      path: "/sales-dashboard",
      name: "Sales-dashboard",
      component: SalesData,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt") == null) {
      next({
        path: "/login",
        name: "Login",
      });
    } else next();
  } else next();
});

export default router;
